import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "ifttt",
  "use": "ifttt-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"ifttt\"><path d=\"M1 1h18v11.268H1z\" opacity=\".7\" /><path d=\"M1 12.268h11.268V19H1z\" opacity=\".4\" /><path d=\"M12.268 12.268H19V19h-6.732z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol